// @flow
import React, { useCallback, useState } from 'react';
import { StyleSheet, View } from 'react-native';

const HexagonMask = () => null;

export default HexagonMask;
